





























import { Vue, Component } from 'vue-property-decorator'
import { getConfig, updateConfig } from "@/store/config"
import { alert } from "@/utils/notification"

const KEY = "mark-query"

@Component
export default class MarkQueryConfig extends Vue {
  config = {
    title: 'loading',
    description: [] as string[]
  }

  async created() {
    const config = await getConfig(KEY)
    this.config = config
  }

  async submit() {
    try {
      await updateConfig(KEY, this.config)
      alert("更新成功")
    } catch(e) {
      alert("更新失败", e)
    }
  }

  addDescription() {
    this.config.description = [...this.config.description, ""]
  }

  removeDescription(index: number) {
    this.config.description.splice(index, 1)
  }
}
